export default [
  {
    date: 1542834568167,
    row: 20,
    col: 20,
    segments: [
      [1, 1, 3, 1],
      [3, 1, 5, 1],
      [5, 1, 5, 3],
      [5, 3, 5, 5],
      [5, 5, 1, 5],
      [1, 5, 1, 2],
      [1, 2, 4, 2],
      [4, 2, 4, 4],
      [4, 4, 2, 4],
      [2, 4, 2, 3],
      [2, 3, 3, 3],
      [2, 5, 2, 16],
      [4, 5, 4, 16],
      [1, 16, 3, 16],
      [3, 16, 5, 16],
      [5, 16, 5, 18],
      [5, 18, 5, 20],
      [5, 20, 1, 20],
      [1, 20, 1, 17],
      [1, 17, 4, 17],
      [4, 17, 4, 19],
      [4, 19, 2, 19],
      [2, 19, 2, 18],
      [2, 18, 3, 18],
      [5, 17, 16, 17],
      [5, 19, 16, 19],
      [20, 16, 18, 16],
      [18, 16, 16, 16],
      [16, 16, 16, 18],
      [16, 18, 16, 20],
      [16, 20, 20, 20],
      [20, 20, 20, 17],
      [20, 17, 17, 17],
      [17, 17, 17, 19],
      [17, 19, 19, 19],
      [19, 19, 19, 18],
      [19, 18, 18, 18],
      [17, 16, 17, 5],
      [19, 16, 19, 5],
      [20, 1, 16, 1],
      [16, 1, 16, 5],
      [16, 5, 20, 5],
      [20, 5, 20, 2],
      [20, 2, 17, 2],
      [17, 2, 17, 4],
      [17, 4, 19, 4],
      [19, 4, 19, 3],
      [19, 3, 18, 3],
      [16, 2, 5, 2],
      [5, 4, 16, 4],
      [16, 5, 16, 3],
      [16, 1, 18, 1],
      [8, 8, 13, 8],
      [8, 8, 8, 13],
      [8, 13, 13, 13],
      [13, 13, 13, 8],
      [13, 9, 9, 9],
      [9, 9, 9, 12],
      [9, 12, 13, 12],
      [13, 12, 13, 10],
      [13, 10, 10, 10],
      [10, 10, 10, 11],
      [10, 11, 12, 11],
      [12, 11, 12, 10],
      [13, 8, 16, 5],
      [8, 8, 5, 5],
      [8, 13, 5, 16],
      [13, 13, 16, 16],
      [5, 5, 9, 8],
      [5, 5, 10, 8],
      [12, 8, 16, 5],
      [11, 8, 16, 5],
      [13, 12, 16, 16],
      [13, 11, 16, 16],
      [8, 12, 5, 16],
      [8, 11, 5, 16],
      [16, 5, 13, 9],
      [16, 5, 13, 10],
      [5, 5, 8, 9],
      [5, 5, 8, 10],
      [4, 10, 8, 10],
      [4, 11, 8, 11],
      [13, 10, 17, 10],
      [13, 11, 17, 11],
      [10, 4, 10, 8],
      [11, 4, 11, 8],
      [10, 13, 10, 17],
      [11, 13, 11, 17],
      [16, 16, 12, 13],
      [5, 16, 9, 13],
      [5, 16, 10, 13],
      [11, 13, 16, 16],
      [4, 11, 6, 10],
      [6, 10, 8, 11],
      [4, 10, 6, 11],
      [6, 11, 8, 10],
      [10, 4, 11, 6],
      [11, 6, 10, 8],
      [11, 4, 10, 6],
      [10, 6, 11, 8],
      [10, 13, 11, 15],
      [11, 15, 10, 17],
      [11, 17, 10, 15],
      [10, 15, 11, 13],
      [13, 10, 15, 11],
      [15, 11, 17, 10],
      [17, 11, 15, 10],
      [15, 10, 13, 11],
      [5, 2, 10, 4],
      [11, 4, 16, 2],
      [5, 4, 10, 2],
      [11, 2, 16, 4],
      [10, 2, 11, 4],
      [11, 2, 10, 4],
      [2, 10, 4, 5],
      [2, 5, 4, 10],
      [4, 11, 2, 16],
      [2, 11, 4, 16],
      [5, 17, 10, 19],
      [5, 19, 10, 17],
      [11, 17, 16, 19],
      [11, 19, 16, 17],
      [10, 17, 11, 19],
      [11, 17, 10, 19],
      [2, 10, 4, 11],
      [4, 10, 2, 11],
      [17, 5, 19, 10],
      [17, 10, 19, 5],
      [17, 11, 19, 16],
      [19, 11, 17, 16],
      [17, 11, 19, 10],
      [17, 10, 19, 11],
      [11, 17, 14, 15],
      [15, 14, 17, 11],
      [17, 10, 15, 7],
      [14, 6, 11, 4],
      [10, 4, 7, 6],
      [6, 7, 4, 10],
      [4, 11, 6, 14],
      [7, 15, 10, 17],
      [13, 10, 12, 10],
    ],
  },
];
